<template>
  <div id="posts-list">
    <div class="container">
      <!-- Feed of posts -->
      <table class="table" v-if="posts.length">
        <thead>
          <tr>
            <th scope="col" width="60"><i class="far fa-image"></i></th>
            <th scope="col">Title</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="post in posts">
            <td @click="openPostModal(post)" class="td-image clickable"><img v-for="media in post.media.slice(0, 1)" :src="media.small"></td>
            <td @click="openPostModal(post)" class="clickable">{{ post.title }}</td>
            <td>
              <button class="btn btn-secondary btn-sm" @click="addToListsModal(post)" :fullPost="post">Add to lists</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else>
        <div class="card">
          <div class="card-body">
            <p class="card-text">There are currently no posts</p>
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div> <!-- v-else -->
    </div><!-- /.container -->


    <ListsSelectModal v-if="ListsSelectModalOpen == true" v-on:closeListsSelectModal="closeListsSelectModal()" :fullPost="fullPost"></ListsSelectModal>


  </div><!-- /#posts-list -->
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  const fb = require('../firebaseConfig.js')
  import ListsSelectModal from './ListsSelectModal.vue'

  export default {
    data() {
      return {
        ListsSelectModalOpen: false,
        fullPost: {}
      }
    },
    components: { ListsSelectModal },
    computed: {
      ...mapState(['userProfile', 'currentUser', 'posts', 'lists'])
    },
    methods: {
      addToListsModal(post) {
        this.fullPost = post
        this.ListsSelectModalOpen = true
      },
      closeListsSelectModal() {
        this.ListsSelectModalOpen = false
      },
      openPostModal(post) {
        this.$emit('openPostModal', post)
      }
    },
    filters: {
      formatDate(val) {
        if (!val) { return '-' }
        let date = val.toDate()
        return moment(date).fromNow()
      },
      trimLength(val) {
        if (val.length < 200) {
          let regex = /(<([^>]+)>)/ig;
          let cleanVal = val.replace(regex, " ");
          return cleanVal
         }
        let regex = /(<([^>]+)>)/ig;
        let cleanVal = val.replace(regex, " ");
        return `${cleanVal.substring(0, 200)}...`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PostsList.vue